<script setup lang="ts">
import {
  ArticleItem,
  BlogArticleProps,
  TransformedArticle,
  articleTransformer,
  sortArticles,
} from '../blogArticleHelper'

const props = withDefaults(defineProps<BlogArticleProps>(), {
  showAsCarousel: true,
  limit: 8,
})
const { blogArticles, supportingData, connectedContentPillar } = props
const { getEntries } = useContentful()
const articles = ref<TransformedArticle[]>([])
const categoryToSearch = connectedContentPillar?.fields?.category
const isSortByPublishedDateDesc = supportingData?.home?.Algorithm?.value === 'publishDateDesc'
const orderFilter = isSortByPublishedDateDesc ? { order: '-fields.publishedDate' } : {}

if (blogArticles && blogArticles.length) {
  const transformedArticles = articleTransformer(blogArticles)
  articles.value = isSortByPublishedDateDesc ? sortArticles(transformedArticles) : transformedArticles
} else {
  const { data } = await useAsyncData(`FeaturedBlogArticlePanel:${categoryToSearch}`, async () => {
    const entries = await getEntries({
      content_type: 'blogArticle',
      'fields.category': categoryToSearch,
      ...orderFilter,
      limit: props.limit,
    })
    if (!entries || !entries.items) {
      return undefined
    }
    return entries.items
  })
  articles.value = articleTransformer(data.value as ArticleItem[])
}
</script>

<template>
  <section class="featured-blog-article-panel">
    <template v-if="articles && articles.length > 0">
      <Carousel v-if="showAsCarousel" :slides-per-view="1" :slides-per-group="1" :items="articles">
        <template #swiperSlide="{ item }">
          <ArticleCard variant="featured-article" :item="item" />
        </template>
      </Carousel>
      <template v-else>
        <ArticleCard v-for="article in articles" :item="article" variant="featured-article" />
      </template>
    </template>
  </section>
</template>

<style lang="postcss">
.featured-blog-article-panel {
  max-width: 80rem;
  padding: var(--space-50);
  margin: 0 auto;
}
</style>
